import { render, staticRenderFns } from "./GridObservacion.vue?vue&type=template&id=35d9da00&"
import script from "./GridObservacion.vue?vue&type=script&lang=js&"
export * from "./GridObservacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports